import { render } from "./ds-period-view.vue?vue&type=template&id=6f2ed5d4"
import script from "./ds-period-view.vue?vue&type=script&setup=true&lang=js"
export * from "./ds-period-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/tep/tep-nsi/ds-period-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f2ed5d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f2ed5d4', __exports__)) {
    api.reload('6f2ed5d4', __exports__)
  }
  
  module.hot.accept("./ds-period-view.vue?vue&type=template&id=6f2ed5d4", () => {
    api.rerender('6f2ed5d4', render)
  })

}


export default __exports__